import { jsx as _jsx } from "react/jsx-runtime";
import { useStylesV2 } from '@kubit/web-ui-components/hooks/useStyles';
import { STYLES_NAME } from '../../constants/stylesName/stylesName';
import { BadgeLogoStandAlone } from './badgeLogoStandAlone';
import { BadgeLogoSizeType } from './types/badgeLogoSizeType';
export const BadgeLogo = ({ variant, size = BadgeLogoSizeType.MEDIUM, ...props }) => {
    const styles = useStylesV2({
        styleName: STYLES_NAME.BADGE_LOGO,
        variantName: variant,
    });
    const sizeStyles = useStylesV2({
        styleName: STYLES_NAME.BADGE_LOGO,
        variantName: size,
    });
    return _jsx(BadgeLogoStandAlone, { ...props, sizeStyles: sizeStyles, styles: styles });
};
//# sourceMappingURL=badgeLogo.js.map